import React from 'react'
import NarrowApp from './NarrowApp'
import WideApp from './WideApp'
import useMedia from '../hooks/useMedia'

export default function App () {
  const layout = useMedia(['(min-width: 872px)'], ['wide'], 'narrow')
  return layout === 'narrow' ? <NarrowApp /> : <WideApp />
}
